<template>
    <div class="card">
        <div class="card-header">
            <slot name="header"/>
        </div>
        <div class="card-body row m-2">
            <div v-if="window.width >= 768" class="el-col-sm-24 teal-text">
                <div class="el-col-sm-7 inline">
                    <h6>{{$t('Team members')}}</h6>
                </div>
                <div class="el-col-sm-5 inline">
                    <h6>{{$t('Average')}}</h6>
                </div>
                <div class="el-col-sm-8 inline">
                    <h6>{{$t('Details')}}</h6>
                </div>
                <div class="el-col-sm-4 inline">
                    <h6>{{$t('Actions')}}</h6>
                </div>
                <div class="el-col-sm-24">
                    <hr class="mb-1 mt-1">
                </div>
            </div>
            <div class="alert-indicator-red alert-indicator-green"></div>
            <div class="col-sm-12 p-2" v-for="teamMember in value" :key="teamMember._id">
                <template>
                    <div v-if="window.width >= 768" class="el-col-sm-7 pt-2 inline-table">
                        {{ teamMember.user | formatDisplayName }}
                    </div>
                    <div v-else class="row">
                        <div class="col-12">{{ teamMember.user | formatDisplayName }}</div>
                    </div>
                    <div v-if="window.width >= 768" class="el-col-sm-5 inline-table">
                        <el-tooltip :content="`${$t('Average')} - ${$t('Last Query')} - ${dateFormatter(teamMember)}`"
                                    placement="bottom"
                                    popper-class="grey-tooltip">
                            <status-indicator class="mr-1" :value="teamMember.average" :trend="teamMember.averageTrend" :active="teamMember.user.active"
                                              :precision="1"/>
                        </el-tooltip>
                        <p-button v-if="isUserOwner" round class="m-0 mr-1 btn-team-member-list" type="primary"
                                  size="sm" icon
                                  @click="createTaskAvgClick(teamMember._id, teamMember.lastQuery.query._id, teamMember.average)">
                            <i class="fa fa-bullhorn"/>
                        </p-button>
                        <div v-if="showUserAlert(teamMember.anyAlertActive, isUserOwner)" class="d-inline-flex justify-content-around" v-bind:class="[getAlertIndicatorClass(teamMember.anyAlertActive)]">
                          <div  v-bind:class="[getAlertIndicatorClass(teamMember.anyAlertActive)]">
                            <i class="fa fa-2x" v-bind:class="[getAlertIndicatorClassIcon(teamMember.anyAlertActive)]" style="vertical-align: -5px;"/>
                          </div>
                        </div>
                    </div>
                    <div v-else class="row" style="margin-top: 4px">
                        <div class="col-12">
                            <el-tooltip
                                    :content="`${$t('Average')} - ${$t('Last Query')} - ${dateFormatter(teamMember)}`"
                                    placement="bottom"
                                    popper-class="grey-tooltip">
                                <status-indicator class="mr-1" :value="teamMember.average"
                                                  :trend="teamMember.averageTrend" :precision="1"
                                                  :active="teamMember.user.active"/>
                            </el-tooltip>
                            <p-button v-if="isUserOwner" round class="m-0 mr-1 btn-team-member-list" type="primary"
                                      size="sm" icon
                                      @click="createTaskAvgClick(teamMember._id, teamMember.lastQuery.query._id, teamMember.average)">
                                <i class="fa fa-bullhorn"/>
                            </p-button>
                            <div v-if="showUserAlert(teamMember.anyAlertActive, isUserOwner)" class="d-inline-flex justify-content-around" v-bind:class="[getAlertIndicatorClass(teamMember.anyAlertActive)]">
                              <div v-bind:class="[getAlertIndicatorClass(teamMember.anyAlertActive)]">
                                <i class="fa fa-2x" v-bind:class="[getAlertIndicatorClassIcon(teamMember.anyAlertActive)]" style="vertical-align: -5px;"/>
                              </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="window.width >= 768" class="el-col-sm-8 inline-table">
                        <el-tooltip v-for="(answer, index) in teamMember.answers"
                                    :content="`${languageFormatter(answer.title)} - ${$t('Last Query')} - ${dateFormatter(teamMember)}`"
                                    placement="bottom"
                                    popper-class="grey-tooltip">
                            <status-indicator class="mr-1"
                                              :value="answer.answer"
                                              :key="index"
                                              :precision="1"
                                              :trend="answer.trend"
                                              :active="teamMember.user.active"/>
                        </el-tooltip>
                    </div>
                    <div v-else class="row" style="margin-top: 4px">
                        <div class="col-12">
                            <el-tooltip v-for="(answer, index) in teamMember.answers"
                                        :content="`${languageFormatter(answer.title)} - ${$t('Last Query')} - ${dateFormatter(teamMember)}`"
                                        placement="bottom"
                                        popper-class="grey-tooltip">
                                <status-indicator class="mr-1"
                                                  :value="answer.answer"
                                                  :key="index"
                                                  :precision="1"
                                                  :trend="answer.trend"
                                                  :active="teamMember.user.active"/>
                            </el-tooltip>
                        </div>
                    </div>

                    <div v-if="window.width >= 768" class="el-col-sm-4 inline-table">
                        <p-button v-if="showDetails && (teamMember.datasets)" round
                                  class="m-0 mr-1 btn-team-member-list" type="primary" icon size="sm"
                                  @click="click(teamMember._id)">
                            <i v-if="showDetails[teamMember._id] === true" class="fa fa-chevron-up"/>
                            <i v-if="showDetails[teamMember._id] === false" class="fa fa-chevron-down"/>
                        </p-button>
                        <p-button round class="m-0 mr-1 btn-team-member-list" type="primary" icon size="sm"
                                  @click="$router.push({ name: 'TeamViewMember', params: {...$route.params, mid: teamMember._id } })">
                            <i class="fa fa-arrow-right"/>
                        </p-button>
                    </div>
                    <div v-else class="row" style="margin-top: 4px">
                        <div class="col-12">
                            <p-button v-if="showDetails && (teamMember.datasets)" round
                                      class="m-0 mr-1 btn-team-member-list" type="primary" icon size="sm"
                                      @click="click(teamMember._id)">
                                <i v-if="showDetails[teamMember._id] === true" class="fa fa-chevron-up"/>
                                <i v-if="showDetails[teamMember._id] === false" class="fa fa-chevron-down"/>
                            </p-button>
                            <p-button round class="m-0 mr-1 btn-team-member-list" type="primary" icon size="sm"
                                      @click="$router.push({ name: 'TeamViewMember', params: {...$route.params, mid: teamMember._id } })">
                                <i class="fa fa-arrow-right"/>
                            </p-button>
                        </div>
                    </div>
                    <div :class="`${window.width < 768 ? 'col-12 p-0' : 'el-col-sm-24'} pt-4`"
                         v-if="showDetails && showDetails[teamMember._id]">
                        <layout-wrapper v-for="(dataset, key) in teamMember.datasets" :key="key" class="inline chart-responsiveness pl-0 pr-3"
                                        :length="Object.keys(teamMember.datasets).length">
                            <template slot="body">
                                <basic-chart :data="dataset"
                                             :badge-value="dataset.average"
                                             :title="dataset.title | languageString"
                                             icon="fa fa-bullhorn"
                                             link="true"
                                             :isUserOwner="isUserOwner"
                                             :alertActive="dataset.alertActive"
                                             @clicked="createTaskQuestionClick(teamMember._id, teamMember.lastQuery.query._id, key, dataset.average)"
                                />
                            </template>
                        </layout-wrapper>
                    </div>
                    <div :class="`${window.width < 768 ? 'col-12 p-0' : 'el-col-sm-24'}`">
                        <hr class="mb-0">
                    </div>
                </template>
            </div>
        </div>

        <modal v-model="showDialog" :title="$t('Create Task')" :disabled="!isEnabled()" :submit="save" :cancel="cancel"
               submit-text="Save">
            <template slot="body">
                <fg-input name="taskTitle"
                          required
                          :label="$t('Title')"
                          autocomplete="off"
                          :placeholder="$t('Title')"
                          v-model="task.title">
                </fg-input>
                <fg-input name="taskDescription" :label="$t('Description')" required>
                    <el-input type="textarea"
                              :placeholder="$t('Description')"
                              :autosize="{ minRows: 3, maxRows: 4}"
                              v-model="task.description"/>
                </fg-input>
                <fg-input :label="$t('Due date')"
                          name="dueDate"
                          v-model="task.dueDate">
                    <el-date-picker v-model="task.dueDate" type="date" placeholder="Pick a date"/>
                </fg-input>
            </template>
        </modal>

    </div>
</template>

<script>
  import { Input, DatePicker, Tooltip } from 'element-ui'
  import BasicChart from '../../Dashboard/Components/BasicChart'
  import StatusIndicator from '../../Dashboard/Components/StatusIndicator'
  import Modal from '../../Dashboard/Components/BasicModal'
  import LayoutWrapper from '../../UIComponents/LayoutWrapper'
  import { mapActions } from 'vuex'
  import isEmpty from 'lodash/isEmpty'

  export default {
    name: 'TeamMemberList',
    components: {
      BasicChart,
      StatusIndicator,
      Modal,
      LayoutWrapper,
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Tooltip.name]: Tooltip
    },
    props: {
      value: Array,
      isUserOwner: Boolean
    },
    watch: {
      value (val) {
        if (val) {
          this.setShowDetails(val)
        }
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      this.setShowDetails(this.value)
    },
    data () {
      return {
        showDetails: null,
        task: {},
        showDialog: false,
        window: {
          width: 0
        }
      }
    },
    methods: {
      ...mapActions('user/tasks', ['createTask']),
      setShowDetails (value) {
        let obj = {}
        value.forEach(member => {
          obj[member._id] = false
        })
        this.showDetails = obj
      },
      click (_id) {
        const prev = this.showDetails
        this.showDetails = Object.assign(prev, { [_id]: !prev[_id] })
      },
      createTaskAvgClick (userId, query, value) {
        this.showDialog = true
        this.task = {
          trigger: {
            type: 'average',
            user: userId,
            query: query,
            team: this.$route.params.tid,
            value: value
          },
          assigneeType: 'user',
          assignee: userId,
          dueDate: Date.now()
        }
      },
      createTaskQuestionClick (userId, query, question, value) {
        this.showDialog = true
        this.task = {
          trigger: {
            type: 'question',
            user: userId,
            query: query,
            team: this.$route.params.tid,
            question: question,
            value: value
          },
          assigneeType: 'user',
          assignee: userId,
          dueDate: Date.now()
        }
      },
      cancel: function () {
        this.showDialog = false
      },
      save: async function () {
        const { title, assigneeType, description, trigger, assignee, dueDate } = this.task
        const data = { title, assigneeType, description, trigger, assignee, dueDate }

        try {
          await this.createTask({ item: data })
          this.$notify({ message: this.$t('Successfully added task.'), type: 'success' })
        } catch (e) {
          this.$notify({ message: e.message, type: 'danger' })
        }

        this.showDialog = false
      },
      clicked (id) {
        alert(id)
      },
      handleResize () {
        this.window.width = window.innerWidth
      },
      dateFormatter: function (teamMember) {
        return this.$options.filters.formatDate(teamMember.lastQuery.query.executionTime)
      },
      languageFormatter: function (item) {
        return this.$options.filters.languageString(item)
      },
      isEnabled: function () {
        const { title, description } = this.task
        return !isEmpty(title) && !isEmpty(description)
      },
      getAlertIndicatorClass: function (alertValue) {
        if (alertValue < 0) {
          return 'alert-indicator-red'
        } else if (alertValue > 0) {
          return 'alert-indicator-green'
        } else {
          return ''
        }
      },
      getAlertIndicatorClassIcon: function (alertValue) {
        if (alertValue < 0) {
          return 'fa-exclamation-triangle'
        } else if (alertValue > 0) {
          return 'fa-check-circle'
        } else {
          return ''
        }
      },
      showUserAlert: function (alertValue, isOwner) {
        return ['premium'].includes(this.$auth.user.customer.settings.contract.packageType) &&
          alertValue !== 0 &&
          isOwner
      }
    }
  }
</script>
<style lang="scss">
    .btn-team-member-list {
        height: 40px !important;
        width: 40px !important;
    }

    .inline-table {
        display: inline-table;
    }
    .no-div-break {
      display: inline;
      float: left;
    }
    .nowrap {
      white-space: nowrap;
    }
    .teal-text {
      color: #0097ae !important;
    }

    @media (max-width: 590px) {
      .chart-responsiveness {
        padding-right: 0px !important;
      }
    }

    .alert-indicator-red {
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  display: inline-block;
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 1px 1px;
  padding: 0 15px;
  color: #ff0000 !important;
  &.full-width {
    width: 100%;
  }
  &-cell {
    display: inline-block;
    padding: 0 4px;
    text-align: center;
    vertical-align: -5px !important;
    color: #ff0000 !important;
  }
  :last-child {
    text-align: left;
  }
}

.alert-indicator-green {
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  display: inline-block;
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 1px 1px;
  padding: 0 15px;
  color: #009800 !important;
  &.full-width {
    width: 100%;
  }
  &-cell {
    display: inline-block;
    padding: 0 4px;
    text-align: center;
    vertical-align: -5px !important;
    color: #009800 !important;
  }
  :last-child {
    text-align: left;
  }
}

    .grey-tooltip {
      background: #6f6f6f !important;
    }
    
    .el-tooltip__popper[x-placement^="bottom"] {
      margin-top: 5px;
      .popper__arrow {
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #6f6f6f transparent;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    .el-tooltip__popper[x-placement^="top"] {
      margin-bottom: 5px;
      .popper__arrow {
        border-width: 5px 5px 0 5px;
        border-color: #6f6f6f transparent transparent transparent;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    .el-tooltip__popper[x-placement^="bottom"] .popper__arrow::before {
      background: #6f6f6f !important;
    }

    .el-tooltip__popper[x-placement^="bottom"] .popper__arrow::after {
      top: 1px;
      margin-left: -5px;
      border-top-width: 0;
      border-bottom-color: #6f6f6f;
    }

    .el-tooltip__popper[x-placement^="top"] .popper__arrow::before {
      background: #6f6f6f !important;
    }

    .el-tooltip__popper[x-placement^="top"] .popper__arrow::after {
      bottom: 1px;
      margin-left: -5px;
      border-top-color: #6f6f6f;
      border-bottom-width: 0;
    }


    @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
    }
</style>
